import TextareaAutogrow from "stimulus-textarea-autogrow"

export default class extends TextareaAutogrow {
  connect() {
    super.connect()
    this.resizeTextarea = this.resizeTextarea.bind(this)


    this.resizeTextarea()
    document.addEventListener('turbo:frame-load', this.resizeTextarea)
    document.addEventListener('turbo:render', this.resizeTextarea)
  }

  disconnect() {
    super.disconnect()
    document.removeEventListener('turbo:frame-load', this.resizeTextarea)
    document.removeEventListener('turbo:render', this.resizeTextarea)
  }

  resizeTextarea() {
    requestAnimationFrame(() => {
      this.element.style.height = 'auto'
      this.element.style.height = this.element.scrollHeight + 'px'
    })
  }
}
